import api from './api'

export const adminPushCondicionService = {
  /**
   * @param {{ search?: string, page?: number, per_page?: number }} params
   */
  async mascotaCondiciones(params = {}) {
    const response = await api.get('/admin/push-condicion-salud/mascota-condiciones', { params })
    return response.data
  },

  /**
   * @param {{ id_mascota_condicion: number|string, id_usuario_destino: number|string, titulo?: string, mensaje?: string }} payload
   */
  async enviar(payload) {
    const response = await api.post('/admin/push-condicion-salud/enviar', payload)
    return response.data
  },
}
